import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ThemeState {
  mode: 'light' | 'dark'
  primaryColor: string
  secondaryColor: string
}

const initialState: ThemeState = {
  mode: 'light',
  primaryColor: '#6c5ce7',
  secondaryColor: '#a29bfe',
}

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleMode: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light'
    },
    setPrimaryColor: (state, action: PayloadAction<string>) => {
      state.primaryColor = action.payload
    },
    setSecondaryColor: (state, action: PayloadAction<string>) => {
      state.secondaryColor = action.payload
    },
  },
})

export const { toggleMode, setPrimaryColor, setSecondaryColor } = themeSlice.actions
export default themeSlice.reducer
